import React from 'react';
import { Provider } from 'react-redux';
import createRender from 'found/lib/createRender';
import { Resolver } from 'found-relay';
import ScrollManager from 'found-scroll/lib/ScrollManager';
import FarceActions from 'farce/lib/Actions';
import createConnectedRouter from 'found/lib/createConnectedRouter';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { environment } from './environment';

import store from './redux/store/configureStore';

// injectTapEventPlugin();
store.dispatch(FarceActions.init());
const render = createRender({});

const RenderScrollManager = renderArgs => (
  <ScrollManager renderArgs={renderArgs}>{render(renderArgs)}</ScrollManager>
);

const ConnectedRouter = createConnectedRouter({
  render: RenderScrollManager,
});

const Root = () => (
  <Provider store={store}>
    <ConnectedRouter resolver={new Resolver(environment)} />
  </Provider>
);

// initialize LaunchDarkly for feature flags
// user will be populated later when we have access to it
export default withLDProvider({
  clientSideID: process.env.LAUNCH_DARKLY_CLIENT_SIDE_ID,
  user: {
    anonymous: true,
  },
})(Root);
